import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-material',
  templateUrl: './material.component.html',
  styleUrls: ['./material.component.scss']
})

/**
 * Material component - handling the material-design icon with navbar and content
 */
export class MaterialComponent implements OnInit {
  // bread crumb items
  breadCrumbItems: Array<any>;

  constructor() { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'Aivis', path: '/' }, { label: 'Icons', path: '/' }, { label: 'Material', path: '/', active: true }];

  }

}
